import { reactive } from 'vue';

export const criarGabinetePessoa = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idlocalidade: 0,
        idtppessoa: 0,
        cdpessoa: 0,
        nmpessoa: '',
        apelido: '',
        sigla: '',
        cpf: '',
        cpfnros: '',
        ie: 0,
        endereco: '',
        nmendereco: 0,
        complemento: '',
        bairro: '',
        nmmunicipio: '',
        uf: '',
        cep: '',
        dtnascimento: '',
        celular: '',
        email: '',
        facebook: '',
        instagram: '',
        empresa_nome: '',
        empresa_cnpj: '',
        empresa_ie: 0,
        idlogin: 0,
        idusuario: 0
    });
};